import React from 'react';
import { Route, Redirect } from 'react-router-dom';


const ProtectedRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  return (
    <Route {...rest} render={
      props => {
        if (isAuthenticated) {
          return <Component {...rest} {...props} />
        } else {
          return <Redirect to={
            {
              pathname: '/auth/login',
              state: {
                from: props.location
              }
            }
          } />
        }
      }
    } />
  )
}

export default ProtectedRoute;